export default __webpack_public_path__ + "static/media/viewers.b75cc026.svg";